

var venue_id = "nam-us-00034-cavaliers";
var topview_id = "blockmap";
var map_id_mini = "blockmap_minimap";
var url = "https://www.nba.com/cavaliers/tickets";
var integrationType = "dvm";
//var integrationType = 'bumper';

interfaceSetTicketsURL(url);

var config_promise = $.getJSON("src/js/config/config.json");
var config = null;
Promise.all([config_promise]).then(function(res){
    config = res[0];
}).catch(function(err) {
    console.error(err);
});


/* D2M */
var instance_options = {
    version: "latest",
    plugins:['best_nodes'],
    container: "viewer",
    new_styles: true,
    callbacks: {
        click: onClickCB,
        enter: onEnterCB,
        leave: onLeaveCB,
        zooming: onZoomCB,
        panning: onZoomingPanning
    }
};


var instance_options_mini = {
    container: "blockmap-mini"
};

var viewer3d_input_options = {
    container: "view3d",
    plugins: ['gallery','navigation'],
    callbacks: {
        click_navigation_node: dvmViewer3dOnClickNavNode
    }
};

var viewer_promise = DVM.loadModule("map_viewer", instance_options);
var viewer_mini_promise = DVM.loadModule("map_viewer", instance_options_mini);
var viewer_3d_promise = DVM.loadModule("3d_viewer", viewer3d_input_options);
var filtering = $.getJSON("src/js/config/filtering/filtering.json");
var navigation = $.getJSON("src/js/config/navigation/navigation.json");
var section_types = $.getJSON("src/js/config/filtering/areafilter.json");
var vipnavigation = $.getJSON("src/js/config/navigation/vip.json");
var outdoor_indoor = $.getJSON("src/js/config/navigation/outdoor_indoor.json");
var suites = $.getJSON("src/js/config/navigation/suites.json");


Promise.all([viewer_promise, viewer_mini_promise, viewer_3d_promise,filtering,
    navigation,section_types,vipnavigation,outdoor_indoor,suites
    ])
    .then(function(result) {
        viewer = result[0];
        viewer_mini = result[1];
        viewer_3d= result[2];
        
        filtering = result[3];
        navigation = result[4];
        section_types = result[5];
        vipnavigation = result[6];
        
        outdoor_indoor = result[7];
        suites = result[8];

        dvmBindInterfaceEvents();
        dvmSetInitialFlags();
        dvmStart();
    })
    .catch(function(err) {
        console.error(err);
    });

